export { documentDetailsRoute } from './route'
